import { fromJS, List } from 'immutable';

export const USER_CLOSED_NO_LOCATION_POINT_TOAST =
  'userClosedNoLocationPointToast';
export const MAX_PRODUCT_QUANTITY_TOOLTIP_CLOSED =
  'maxProductQuantityTooltipClosed';
export const MEASURENMENT_UNITS = 'measurenmentUnits';
export const ONLINE_PAYMENT_TOOLTIP_CLOSED = 'onlinePaymentTooltipClosed';
export const SECTIONS_LIST = 'sectionsList';
export const IS_FETCHING_SECTION_LIST = 'isFetchingSectionList';
export const HAS_FETCHED_SECTION_LIST = 'hasFetchedSectionList';
export const GROCERIES_TAB_KEY = 'groceriesTab';
export const ONE_CLICK_PRODUCT_SELECTED = 'oneClickProductSelected';
export const TOTAL_SECTIONS = 'totalSections';
export const EXTENDED_MENU_SECTION = 'extendedMenuSection';
export const SECTIONS_COUNT = 'count';
export const STOP_FETCHING_SECTIONS = 'stopFetchingSection';
export const GROCERIES_TAB = {
  CATALOGS: 1,
  SECTIONS: 2,
};
export const SECTIONS_HEIGHTS = 'sectionsHeights';
export const CAPACITY_CHECK = 'capacityCheck';
export const ALL_SECTIONS = 'allSections';
export const IS_FETCHING_ALL_SECTIONS = 'isFetchingAllSections';
export const SECTION_TAB_ID = 'sectionTabId';
export const DISTANCE_VENDOR_PICKUP = 'distanceVendorPickup';
export const PREFERRED_DISHES = 'preferredDishes';
export const IS_FETCHING_PREFERRED_DISHES = 'isFetchingPreferredDishes';

export const createModel = ({
  userClosedNoLocationPointToast = false,
  maxProductQuantityTooltipClosed = false,
  measurenmentUnits = [],
  onlinePaymentTooltipClosed = false,
  sectionsList = List(),
  isFetchingSectionList = false,
  hasFetchedSectionList = true,
  groceriesTab = GROCERIES_TAB.CATALOGS,
  totalSections = null,
  extendedMenuSection = null,
  sectionsCount = null,
  stopFetchingSection = false,
  sectionsHeights = {},
  capacityCheck = {},
  oneClickProductSelected = 0,
  allSections = List(),
  isFetchingAllSections = false,
  sectionTabId = null,
  distanceVendorPickup = null,
  preferredDishes = null,
  isFetchingPreferredDishes = false,
} = {}) =>
  fromJS({
    [USER_CLOSED_NO_LOCATION_POINT_TOAST]: userClosedNoLocationPointToast,
    [MAX_PRODUCT_QUANTITY_TOOLTIP_CLOSED]: maxProductQuantityTooltipClosed,
    [MEASURENMENT_UNITS]: measurenmentUnits,
    [ONLINE_PAYMENT_TOOLTIP_CLOSED]: onlinePaymentTooltipClosed,
    [SECTIONS_LIST]: sectionsList,
    [IS_FETCHING_SECTION_LIST]: isFetchingSectionList,
    [HAS_FETCHED_SECTION_LIST]: hasFetchedSectionList,
    [GROCERIES_TAB_KEY]: groceriesTab,
    [ONE_CLICK_PRODUCT_SELECTED]: oneClickProductSelected,
    [TOTAL_SECTIONS]: totalSections,
    [EXTENDED_MENU_SECTION]: extendedMenuSection,
    [SECTIONS_COUNT]: sectionsCount,
    [STOP_FETCHING_SECTIONS]: stopFetchingSection,
    [SECTIONS_HEIGHTS]: sectionsHeights,
    [CAPACITY_CHECK]: capacityCheck,
    [ALL_SECTIONS]: allSections,
    [IS_FETCHING_ALL_SECTIONS]: isFetchingAllSections,
    [SECTION_TAB_ID]: sectionTabId,
    [DISTANCE_VENDOR_PICKUP]: distanceVendorPickup,
    [PREFERRED_DISHES]: preferredDishes,
    [IS_FETCHING_PREFERRED_DISHES]: isFetchingPreferredDishes,
  });

const model = createModel();

export default model;
